<template>
	<div class="input-container">
		<div class="input-title">Field Placeholder</div>
		<div class="input-box"><input v-model="value.placeholder" type="text"></div>
	</div>
</template>

<script>

export default {

	props: ['value'],

};

</script>
